import { general } from './general';

export const checkbox = (data = {}) => general('checkbox', (data || {}));
